import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

interface IFilterChipProps {
  label: string;
  value: string;
  onRemove: () => void;
  className?: string;
}

const FilterChip: React.FC<IFilterChipProps> = ({
  label,
  value,
  onRemove,
  className,
}) => {
  return (
    <Group
      className={`rounded-lg border border-blue-900/50 bg-[#12161f]/80 px-3 py-1.5 backdrop-blur-sm ${className}`}
      gap={6}
    >
      <Text className="font-medium text-blue-400" size="sm">
        {label}:
      </Text>
      <Text className="text-blue-200" size="sm">
        {value}
      </Text>
      <ActionIcon
        onClick={onRemove}
        aria-label="Remove filter"
        variant="transparent"
      >
        <IconX className="text-blue-400 hover:text-blue-200" size={14} />
      </ActionIcon>
    </Group>
  );
};

export default FilterChip;
